export const navItems = [
  { label: "热门榜", href: "#ranking" },
  { label: "实时热度", href: "#trend" },
  { label: "热议焦点", href: "#focus" },
  { label: "资源入口", href: "#resources" },
  { label: "热门专题", href: "#categories" },
];

export const heroStats = [
  { label: "今日话题", value: "3,482" },
  { label: "实时在线", value: "12.6万" },
  { label: "热度更新", value: "5 分钟" },
];

export const marqueeItems = [
  { text: "城市地铁新线路今日正式开通", delta: "+18.2%", rising: true },
  { text: "国产新能源车单月交付创新高", delta: "+12.6%", rising: true },
  { text: "秋季悬疑剧口碑低调逆袭", delta: "+9.8%", rising: true },
  { text: "冷空气来袭 换季保暖指南", delta: "+6.4%", rising: true },
  { text: "高校宿舍改造创意刷屏", delta: "+5.1%", rising: true },
  { text: "城市马拉松报名再破纪录", delta: "-2.3%", rising: false },
  { text: "AI 助手走进日常办公场景", delta: "+7.7%", rising: true },
  { text: "老字号联名新品一盒难求", delta: "+3.9%", rising: true },
];

export const hotRanking = [
  {
    id: 1,
    rank: 1,
    title: "城市地铁新线路今日正式开通运营",
    summary: "沿线换乘站点同步启用，早高峰通勤时间平均缩短 18 分钟，周边商圈热度同步走高。",
    category: "城市身边事",
    heatText: "1186.4万",
    heatValue: 1186.4,
    delta: "+18.2%",
    rising: true,
  },
  {
    id: 2,
    rank: 2,
    title: "国产新能源车单月交付量创历史新高",
    summary: "多家品牌公布月度成绩，智能座舱与快充方案成为讨论焦点，订单排期普遍后延。",
    category: "科技数码",
    heatText: "986.7万",
    heatValue: 986.7,
    delta: "+12.6%",
    rising: true,
  },
  {
    id: 3,
    rank: 3,
    title: "秋季悬疑剧低调开播后口碑逆袭",
    summary: "零宣传上线却拿下高分，剧情节奏与开放式结尾引发大量二次解读与讨论。",
    category: "影视综艺",
    heatText: "902.3万",
    heatValue: 902.3,
    delta: "+9.8%",
    rising: true,
  },
  {
    id: 4,
    rank: 4,
    title: "多股冷空气来袭 换季保暖指南来了",
    summary: "北方多地昼夜温差拉大，通勤穿搭与居家保暖好物进入搜索热榜前列。",
    category: "生活日常",
    heatText: "845.1万",
    heatValue: 845.1,
    delta: "+6.4%",
    rising: true,
  },
  {
    id: 5,
    rank: 5,
    title: "高校宿舍改造创意视频刷屏网络",
    summary: "低成本改造方案被大量模仿，收纳与灯光布置成为学生群体的讨论重点。",
    category: "校园热点",
    heatText: "733.9万",
    heatValue: 733.9,
    delta: "+5.1%",
    rising: true,
  },
  {
    id: 6,
    rank: 6,
    title: "城市马拉松报名人数再度突破纪录",
    summary: "赛道沿线观赛点几乎约满，赛事周边酒店与交通攻略同步升温。",
    category: "体育赛事",
    heatText: "688.5万",
    heatValue: 688.5,
    delta: "-2.3%",
    rising: false,
  },
  {
    id: 7,
    rank: 7,
    title: "AI 助手走进日常办公 效率翻倍",
    summary: "写周报、整理会议纪要、生成表格成为高频用法，职场话题热度持续走高。",
    category: "科技数码",
    heatText: "612.7万",
    heatValue: 612.7,
    delta: "+7.7%",
    rising: true,
  },
  {
    id: 8,
    rank: 8,
    title: "老字号点心联名新品一盒难求",
    summary: "限定口味上线即售罄，二手交易平台溢价明显，排队与代购话题升温。",
    category: "财经消费",
    heatText: "556.2万",
    heatValue: 556.2,
    delta: "+3.9%",
    rising: true,
  },
  {
    id: 9,
    rank: 9,
    title: "县城咖啡馆成年轻人周末新去处",
    summary: "小而美的社区咖啡店集中出现，本地生活打卡内容明显增多。",
    category: "生活日常",
    heatText: "498.4万",
    heatValue: 498.4,
    delta: "-1.6%",
    rising: false,
  },
  {
    id: 10,
    rank: 10,
    title: "露营装备租赁生意悄然升温",
    summary: "轻量化装备按次租赁受欢迎，露营与城市周边游话题联动增长。",
    category: "财经消费",
    heatText: "437.8万",
    heatValue: 437.8,
    delta: "+4.2%",
    rising: true,
  },
];

export const topMovers = [
  { id: 1, name: "城市地铁新线路开通", deltaText: "+18.2%", rising: true },
  { id: 2, name: "国产新能源车交付创新高", deltaText: "+12.6%", rising: true },
  { id: 3, name: "秋季悬疑剧口碑逆袭", deltaText: "+9.8%", rising: true },
  { id: 4, name: "AI 助手走进日常办公", deltaText: "+7.7%", rising: true },
  { id: 5, name: "换季保暖指南登上热榜", deltaText: "+6.4%", rising: true },
];

export const hotKeywords = [
  "地铁新线路",
  "新能源车交付",
  "秋季悬疑剧",
  "换季保暖",
  "马拉松报名",
  "AI 办公",
  "露营装备",
  "县城咖啡",
];

export const trendSeries = [
  { time: "00:00", value: 212 },
  { time: "02:00", value: 168 },
  { time: "04:00", value: 140 },
  { time: "06:00", value: 196 },
  { time: "08:00", value: 388 },
  { time: "10:00", value: 642 },
  { time: "12:00", value: 788 },
  { time: "14:00", value: 726 },
  { time: "16:00", value: 864 },
  { time: "18:00", value: 1092 },
  { time: "20:00", value: 986 },
  { time: "22:00", value: 1146 },
];

export const trendStats = [
  { id: 1, label: "今日峰值热度", value: "1,146", unit: "万", icon: "ri-fire-line" },
  { id: 2, label: "平均热度", value: "636", unit: "万", icon: "ri-line-chart-line" },
  { id: 3, label: "讨论增量", value: "+12.6", unit: "%", icon: "ri-chat-smile-2-line" },
  { id: 4, label: "刷新频率", value: "5", unit: "分钟", icon: "ri-refresh-line" },
];

export const focusTopics = [
  {
    id: 1,
    tag: "影视综艺",
    title: "秋季档悬疑剧逆袭出圈",
    summary: "零宣发上线却凭剧情拿下高分，结尾解读刷屏社交平台。",
    heatText: "902.3万",
    comments: "3.4万",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20autumn%20city%20street%20at%20night%20with%20warm%20orange%20street%20lights%20and%20soft%20rain%20reflections%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=focus-topic-a01&orientation=landscape",
  },
  {
    id: 2,
    tag: "科技数码",
    title: "AI 助手正在改变办公方式",
    summary: "写周报、整理纪要、生成表格成为高频用法，效率话题升温。",
    heatText: "612.7万",
    comments: "2.1万",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20minimal%20desk%20workspace%20with%20glowing%20orange%20holographic%20interface%20panels%20over%20dark%20warm%20background%2C%20editorial%20product%20photography&width=800&height=600&seq=focus-topic-a02&orientation=landscape",
  },
  {
    id: 3,
    tag: "体育赛事",
    title: "城市马拉松报名人数再破纪录",
    summary: "赛道观赛点几乎约满，赛事周边酒店与交通攻略同步升温。",
    heatText: "688.5万",
    comments: "1.8万",
    image:
      "https://readdy.ai/api/search-image?query=dynamic%20runners%20at%20a%20city%20marathon%20during%20golden%20hour%20with%20warm%20orange%20atmosphere%20and%20motion%20blur%2C%20editorial%20sports%20photography&width=800&height=600&seq=focus-topic-a03&orientation=landscape",
  },
  {
    id: 4,
    tag: "生活日常",
    title: "换季降温 保暖好物指南",
    summary: "昼夜温差拉大，通勤穿搭与居家保暖好物冲进搜索前列。",
    heatText: "845.1万",
    comments: "2.6万",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20autumn%20fashion%20flat%20lay%20with%20warm%20knitwear%20and%20a%20steaming%20coffee%20cup%20on%20cream%20background%2C%20soft%20natural%20light%2C%20minimal%20styling&width=800&height=600&seq=focus-topic-a04&orientation=landscape",
  },
  {
    id: 5,
    tag: "财经消费",
    title: "老字号联名新品为何一盒难求",
    summary: "限定口味上线即售罄，排队与代购话题同步走高。",
    heatText: "556.2万",
    comments: "1.3万",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20traditional%20chinese%20pastry%20gift%20box%20arranged%20on%20a%20warm%20beige%20surface%20with%20minimal%20styling%20and%20soft%20shadows%2C%20product%20photography&width=800&height=600&seq=focus-topic-a05&orientation=landscape",
  },
  {
    id: 6,
    tag: "校园热点",
    title: "高校宿舍改造创意刷屏",
    summary: "低成本改造方案被大量模仿，收纳与灯光布置成讨论重点。",
    heatText: "733.9万",
    comments: "2.9万",
    image:
      "https://readdy.ai/api/search-image?query=creative%20cozy%20dormitory%20room%20interior%20with%20warm%20string%20lights%20and%20green%20plants%2C%20editorial%20interior%20photography%2C%20soft%20evening%20light&width=800&height=600&seq=focus-topic-a06&orientation=landscape",
  },
];

export const resourceEntries = [
  { id: 1, title: "热度追踪台", desc: "实时榜单速览", icon: "ri-line-chart-line", count: "128 个榜单" },
  { id: 2, title: "话题档案馆", desc: "历史热点回看", icon: "ri-archive-2-line", count: "6,420 条" },
  { id: 3, title: "爆点雷达", desc: "异动实时提醒", icon: "ri-radar-line", count: "24 小时" },
  { id: 4, title: "专题合集", desc: "深度整理打包", icon: "ri-folder-open-line", count: "86 个专题" },
  { id: 5, title: "数据看板", desc: "热度指标可视化", icon: "ri-bar-chart-box-line", count: "32 项指标" },
  { id: 6, title: "入口导航", desc: "常用站点直达", icon: "ri-links-line", count: "210 个入口" },
  { id: 7, title: "订阅提醒", desc: "热点不再错过", icon: "ri-notification-3-line", count: "5 分钟推送" },
  { id: 8, title: "爆料通道", desc: "线索一键投递", icon: "ri-send-plane-line", count: "匿名可选" },
];

export const topicCategories = [
  { id: 1, name: "娱乐八卦", count: "1,286", icon: "ri-star-smile-line" },
  { id: 2, name: "社会民生", count: "964", icon: "ri-building-2-line" },
  { id: 3, name: "科技数码", count: "872", icon: "ri-cpu-line" },
  { id: 4, name: "体育赛事", count: "731", icon: "ri-basketball-line" },
  { id: 5, name: "财经消费", count: "688", icon: "ri-wallet-3-line" },
  { id: 6, name: "影视综艺", count: "642", icon: "ri-movie-2-line" },
  { id: 7, name: "生活日常", count: "598", icon: "ri-home-smile-line" },
  { id: 8, name: "校园热点", count: "455", icon: "ri-graduation-cap-line" },
  { id: 9, name: "城市身边事", count: "412", icon: "ri-map-pin-2-line" },
  { id: 10, name: "游戏电竞", count: "376", icon: "ri-gamepad-line" },
];

export const footerColumns = [
  {
    title: "热门榜入口",
    links: [
      { label: "实时热度榜", href: "#ranking" },
      { label: "飙升话题榜", href: "#ranking" },
      { label: "热议焦点", href: "#focus" },
      { label: "话题排行", href: "#trend" },
    ],
  },
  {
    title: "资源导航",
    links: [
      { label: "爆点雷达", href: "#resources" },
      { label: "话题档案馆", href: "#resources" },
      { label: "数据看板", href: "#resources" },
      { label: "入口导航", href: "#resources" },
    ],
  },
  {
    title: "热门专题",
    links: [
      { label: "娱乐八卦", href: "#categories" },
      { label: "科技数码", href: "#categories" },
      { label: "体育赛事", href: "#categories" },
      { label: "城市身边事", href: "#categories" },
    ],
  },
];